module.exports = __webpack_public_path__ + "img/user_information_batch.1685a9b8.png";